import React, { Fragment } from 'react';
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";
import useListboxFetch from "./useListboxFetch";
import { CommonDropdown } from "./CommonDropdown";

const DropdownCountries = ({ control, name, rules, placeholder, isSearchable, isClearable, isMulti, readOnly } ) =>
{
    const [ loading, items ] = useListboxFetch( {
        url: '/countries', keyFieldName: 'country_id', labelFieldName: 'nicename' } ) ;

    return (
        <Fragment>
            { loading === true && <div className='form-control'><SpinnerDiv/></div> }
            { loading === false && <CommonDropdown items={items} control={control} name={name} rules={rules} placeholder={placeholder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly} /> }
        </Fragment>
    )
}

export default DropdownCountries;
